import { render, staticRenderFns } from "./dialog-excel-tables-products.vue?vue&type=template&id=655ec803&scoped=true&"
import script from "./dialog-excel-tables-products.vue?vue&type=script&lang=js&"
export * from "./dialog-excel-tables-products.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655ec803",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/application/eu/trade-dsm-frontend_2022/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('655ec803')) {
      api.createRecord('655ec803', component.options)
    } else {
      api.reload('655ec803', component.options)
    }
    module.hot.accept("./dialog-excel-tables-products.vue?vue&type=template&id=655ec803&scoped=true&", function () {
      api.rerender('655ec803', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/application-level/helper-components/dialog-excel-tables-products.vue"
export default component.exports